import { render, staticRenderFns } from "./EmployeeDetailsUser.vue?vue&type=template&id=54f3d231"
import script from "./EmployeeDetailsUser.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports